import React from 'react'

type ReviewStepHeaderProps = {
  compact?: boolean
  entityName?: string
  reviewType: 'hospital' | 'agency'
  subtitle?: string
  title?: string
}

export const ReviewStepHeader: React.FC<ReviewStepHeaderProps> = ({
  compact = false,
  entityName,
  reviewType,
  subtitle,
  title,
}) => {
  if (compact) {
    return (
      <div className="mb-6 text-center">
        <p className="text-sm capitalize text-gray-400">{title || `${reviewType} Review`}</p>
        <h1 className="text-xl font-bold text-graphite-grey md:text-2xl">{entityName || `${reviewType} Review`}</h1>
      </div>
    )
  }

  return (
    <div className="mb-8 text-center">
      <h1 className="mb-2 text-4xl font-bold capitalize text-graphite-grey md:text-5xl">
        {title || `${reviewType} Review`}
      </h1>
      {entityName ? (
        <p className="text-lg font-semibold text-graphite-grey">{entityName}</p>
      ) : (
        <p className="text-gray-600">{subtitle || 'Share your experience to help other healthcare workers'}</p>
      )}
    </div>
  )
}
